import React from "react";
import Img1 from "../../assets/ThreeDprinting/Marquee/Marquee Img 3D Printing Koios Engineering Solutions 1.webp";
import Img2 from "../../assets/ThreeDprinting/Marquee/Marquee Img 3D Printing Koios Engineering Solutions 2.webp";
import Img3 from "../../assets/ThreeDprinting/Marquee/Marquee Img 3D Printing Koios Engineering Solutions 3.webp";
import Img4 from "../../assets/ThreeDprinting/Marquee/Marquee Img 3D Printing Koios Engineering Solutions 4.webp";
import Img5 from "../../assets/ThreeDprinting/Marquee/Marquee Img 3D Printing Koios Engineering Solutions 5.webp";
import Img6 from "../../assets/ThreeDprinting/Marquee/Marquee Img 3D Printing Koios Engineering Solutions 6.webp";
import Img7 from "../../assets/ThreeDprinting/Marquee/Marquee Img 3D Printing Koios Engineering Solutions 7.webp";
import Img8 from "../../assets/ThreeDprinting/Marquee/Marquee Img 3D Printing Koios Engineering Solutions 8.webp";
import Img9 from "../../assets/ThreeDprinting/Marquee/Marquee Img 3D Printing Koios Engineering Solutions 9.webp";
import Img10 from "../../assets/ThreeDprinting/Marquee/Marquee Img 3D Printing Koios Engineering Solutions 10.webp";
import Img11 from "../../assets/ThreeDprinting/Marquee/Marquee Img 3D Printing Koios Engineering Solutions 11.webp";
import Img12 from "../../assets/ThreeDprinting/Marquee/Marquee Img 3D Printing Koios Engineering Solutions 12.webp";
import Img13 from "../../assets/ThreeDprinting/Marquee/Marquee Img 3D Printing Koios Engineering Solutions 13.webp";
import Img14 from "../../assets/ThreeDprinting/Marquee/Marquee Img 3D Printing Koios Engineering Solutions 14.webp";
import Img15 from "../../assets/ThreeDprinting/Marquee/Marquee Img 3D Printing Koios Engineering Solutions 15.webp";
import Img16 from "../../assets/ThreeDprinting/Marquee/Marquee Img 3D Printing Koios Engineering Solutions 16.webp";
import Img17 from "../../assets/ThreeDprinting/Marquee/Marquee Img 3D Printing Koios Engineering Solutions 17.webp";
import Img18 from "../../assets/ThreeDprinting/Marquee/Marquee Img 3D Printing Koios Engineering Solutions 18.webp";
import Img19 from "../../assets/ThreeDprinting/Marquee/Marquee Img 3D Printing Koios Engineering Solutions 19.webp";

function Marquee() {
  return (
    <div className="threeD-banner-wrapper threeD-printing-marquee">
      <div className="threeD-banner-marquee">
        <img src={Img1} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img2} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img3} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img4} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img5} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img6} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img7} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img8} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img9} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img10} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img11} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img12} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img13} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img14} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img15} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img16} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img17} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img18} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img19} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img1} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img2} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img3} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img4} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img5} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img6} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img7} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img8} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img9} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img10} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img11} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img12} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img13} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img14} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img15} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img16} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img17} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img18} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img19} alt="Koios Engineering Solution Marquee Img" />
      </div>
    </div>
  );
}

export default Marquee;
